import { render, staticRenderFns } from "./HtmlV1.vue?vue&type=template&id=3fcec8b4&"
import script from "./HtmlV1.vue?vue&type=script&lang=js&"
export * from "./HtmlV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports